import { createSelector } from '@reduxjs/toolkit';
import { HallmapState } from './types';

const selectBase = createSelector(
	(state: RootState) => state,
	(state: RootState) => state.hallmapReducer,
);

export const selectHallmapTables = createSelector(
	selectBase,
	(state: HallmapState) => state.hallmapTables,
);

export const selectResourcesState = createSelector(
	selectBase,
	(state: HallmapState) => state.resourcesState,
);

export const selectResources = createSelector(
	selectBase,
	(state: HallmapState) => state.resources,
);

export const selectHallmapLoader = createSelector(
	selectBase,
	(state: HallmapState) => state.loading,
);

export const selecResourcesFree = createSelector(
	selectBase,
	(state: HallmapState) => state.resourcesFree,
);

export const selectHallmapSelectedTables = createSelector(
	selectBase,
	(state: HallmapState) => state.selectedTables,
);

export const selectHallmapConflictedTables = createSelector(
	selectBase,
	(state: HallmapState) => state.conflictedTables,
);

export const selectisConflict = createSelector(
	selectBase,
	(state: HallmapState) => state.isConflict,
);

export const selectResourcesOptions = createSelector(
	selectBase,
	(state: HallmapState) => {
		return state.resources.map(resource => {
			return { label: resource.name, value: resource.id.toString() };
		});
	},
);

export const selectResourcesNames = createSelector(
	selectBase,
	(state: HallmapState) => {
		const map = new Map();
		state?.resources?.forEach(resource => {
			map.set(resource.id.toString(), resource.name);
		});

		return map;
	},
);

export const selectTableUsedBeforeFlag = createSelector(
	selectBase,
	(state: HallmapState) => {
		return state.tableUsedBefore;
	},
);
